import { memo } from "react";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { DesignMagazinePlanArticleI18nEditContainer } from "./container";

type Props = {
	hotelID: string;
	planID: string;
	langCode: LangCode;
};

export const DesignMagazinePlanArticleI18nEdit = memo(({ hotelID, planID, langCode }: Props) => {
	return <DesignMagazinePlanArticleI18nEditContainer hotelID={hotelID} planID={planID} langCode={langCode} />;
});

DesignMagazinePlanArticleI18nEdit.displayName = "DesignMagazinePlanArticleI18nEdit";
